import React from 'react';

import { useSystemSettings } from 'providers/SystemSettingsProvider';
import Markdown from 'components/Markdown/Markdown';
import SplashScreenTemplate from 'components/SplashScreenTemplate/SplashScreenTemplate';

import './SystemDisabledPage.scss';

const SystemDisabledPage = () => {
  const { disabled_reason } = useSystemSettings();

  return (
    <SplashScreenTemplate className="enkrateia-system-disabled-page">
      <div className="message">
        <Markdown>{disabled_reason ?? ''}</Markdown>
      </div>
    </SplashScreenTemplate>
  );
};

export default SystemDisabledPage;
